import * as React from 'react'

const IconSearch = ({width = 18, height = 18}) => (
  <svg width={width} height={height}>
    <path
      d="M16.029 16.971a.667.667 0 1 0 .942-.942l-.942.942Zm-2.683-4.567a.667.667 0 1 0-.942.942l.942-.942Zm.82-4.237a6 6 0 0 1-6 6V15.5A7.333 7.333 0 0 0 15.5 8.167h-1.333Zm-6 6a6 6 0 0 1-6-6H.834A7.333 7.333 0 0 0 8.167 15.5v-1.333Zm-6-6a6 6 0 0 1 6-6V.833A7.333 7.333 0 0 0 .834 8.167h1.334Zm6-6a6 6 0 0 1 6 6H15.5A7.333 7.333 0 0 0 8.167.833v1.334Zm8.805 13.862-3.625-3.625-.942.942 3.625 3.625.942-.942Z"
      fill="currentColor"
    />
  </svg>
)

export default IconSearch
